import { RouterModule } from '@angular/router';
import { TechmoreSharedModule } from '@techmore/share';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ShareModule } from '../share/share.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DataSearchFormComponent } from './component/data-search-form/data-search-form.component';


/** 素材資料搜尋頁面模組 */
@NgModule({
  declarations: [
    DataSearchFormComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ShareModule,
    FormsModule,
    TranslateModule.forChild(),
    TechmoreSharedModule,
  ],
  exports: [
    DataSearchFormComponent,
  ]
})
export class ShareDataSearchModule { }
